import categoryService from "app/common/services/categoryService";
import {
    CategoryFilterCell,
    DefaultCellRightAlign,
    IndexCell,
    WebsiteTooltipTopCell,
} from "app/components/React/Table/cells";
import { KeywordCompetitorsAffinityCell } from "app/components/React/Table/cells/KeywordCompetitorsAffinityCell";
import { PercentageCellRightAlign } from "app/components/React/Table/cells/PercentageCell";
import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { SelectAllRowsHeaderCellConsumer } from "app/components/React/Table/headerCells/SelectAllRowsHeaderCell";
import { i18nFilter } from "app/filters/i18nFilter";
import { abbrNumberVisitsFilter, percentageFilter, subCategoryFilter } from "app/filters/ngFilters";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { EPresetOption } from "app/common/keyword-research/website-keywords/competitiveFilterPresets";

const i18n = i18nFilter();
interface IWebsiteData {
    Domain: string;
    Affinity: number;
    KwOverlapped: number;
    Category: string;
    Traffic: number;
    TotalTraffic: number;
    Favicon: string;
    url: string;
    index: number;
    childsToShow: number;
}
export const getColumns = ({
    orderBy,
    onSelectCategory,
    isPaid,
    handleOpenQualificationSideBar = undefined,
    params,
    keywordTargetState,
}: any) => {
    const field = orderBy.split(" ")[0];
    const sortDirection = orderBy.split(" ")[1];
    const handleRedirect = (row: IWebsiteData) => {
        return proNavigator.href(keywordTargetState, {
            ...params,
            key: `${params.key},${row.Domain}`,
            trafficPreset: EPresetOption.Overlapping,
            selectedTab: params.selectedTab,
        });
    };

    return [
        {
            fixed: true,
            cellComponent: RowSelectionConsumer,
            sortable: false,
            headerComponent: SelectAllRowsHeaderCellConsumer,
            isResizable: false,
            width: 40,
            visible: categoryService.hasCustomCategoriesPermission() && !proNavigator.isSalesSolution(),
            disableHeaderCellHover: true,
        },
        {
            fixed: true,
            cellComponent: IndexCell,
            sortable: false,
            width: 40,
            isResizable: false,
            disableHeaderCellHover: true,
        },
        {
            width: 217,
            isResizable: true,
            sortable: true,
            field: "Domain",
            showTotalCount: true,
            displayName: i18n(`analysis.competitors.search.organic.table.columns.domain.title`),
            tooltip: i18n(`analysis.competitors.search.organic.table.columns.domain.title.tooltip`),
            cellComponent: (props) => {
                return (
                    <WebsiteTooltipTopCell
                        {...props}
                        handleOpenQualificationSideBar={handleOpenQualificationSideBar}
                    />
                );
            },
        },
        {
            width: 163,
            isResizable: true,
            sortable: true,
            field: "Affinity",
            displayName: i18n(`analysis.competitors.search.organic.table.columns.affinity.title`),
            tooltip: i18n(`analysis.competitors.search.${isPaid ? "paid" : "organic"}.table.columns.affinity.tooltip`),
            cellComponent: KeywordCompetitorsAffinityCell,
            headerComponent: DefaultCellHeader,
            scatterChart: true,
            scatterChartFormatter: (value) =>
                i18n("analysis.competitors.search.table.scatter.tooltip.points", {
                    data: Math.round(value),
                }),
            hideScatterTooltipPill: true,
        },
        {
            width: 135,
            isResizable: true,
            sortable: true,
            field: "KwOverlapped",
            displayName: i18n(`analysis.competitors.search.organic.table.columns.sharedkeywords.title`),
            tooltip: i18n(`analysis.competitors.search.organic.table.columns.sharedkeywords.tooltip`),
            cellComponent: (props) => {
                return (
                    <PercentageCellRightAlign
                        {...props}
                        urlLink={handleRedirect(props.row)}
                    />
                );
            },
            headerComponent: DefaultCellHeader,
            scatterChart: true,
            scatterChartFormatter: (value) => `${percentageFilter()(value || 0, 2)}%`,
            hideScatterTooltipPill: true,
        },
        {
            width: 150,
            isResizable: true,
            sortable: false,
            field: "Traffic",
            displayName: i18n(
                `analysis.competitors.search.organic.table.columns.${
                    isPaid ? "paidtraffic" : "organicsearchalltraffic"
                }.title`,
            ),
            tooltip: i18n(
                `analysis.competitors.search.organic.table.columns.${
                    isPaid ? "paidtraffic" : "organicsearchalltraffic"
                }.tooltip`,
            ),
            cellComponent: (props) => (
                <DefaultCellRightAlign
                    {...props}
                    format="minVisitsAbbr"
                />
            ),
            headerComponent: DefaultCellHeader,
            scatterChart: true,
            scatterChartBenchmark: true,
            scatterChartFormatter: (value) =>
                i18n("analysis.competitors.search.table.scatter.tooltip.visits", {
                    data: abbrNumberVisitsFilter()(value),
                }),
        },
        {
            width: 260,
            isResizable: true,
            sortable: true,
            field: "Category",
            displayName: i18n(`analysis.competitors.search.organic.table.columns.category.title`),
            tooltip: i18n(`analysis.competitors.search.organic.table.columns.category.title.tooltip`),
            cellComponent: (row) => {
                const onItemClick = () => onSelectCategory(row.value);
                const filter = (cat) => {
                    cat = cat.replace("/", "~");
                    return subCategoryFilter()(cat);
                };
                return (
                    <CategoryFilterCell
                        {...row}
                        onItemClick={onItemClick}
                        filter={filter}
                    />
                );
            },
        },
    ].map((col: any) => {
        const isSorted = col.field === field;
        return {
            ...col,
            visible: col.visible !== false,
            headerComponent: col.headerComponent || DefaultCellHeader,
            isSorted,
            sortDirection,
            isResizable: col.isResizable !== false,
        };
    });
};
